import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GfTitleService } from '../../../../services/core.title.service';
import { EventSubscriptionListComponent } from '../../../../../widgets/event-subscription-list/event-subscription-list.component';
import { EventSubscriptionModalComponent } from '../../../../../widgets/event-subscription-modal/event-subscription-modal.component';

@Component({
    selector: 'project-admin-webhooks-subscriptions',
    template: require('./project.admin.webhooks.subscriptions.component.html'),
})
export class ProjectAdminWebhooksSubscriptionsComponent implements OnInit {
    @Input() project: any;
    @ViewChild(EventSubscriptionListComponent) subscriptionList: EventSubscriptionListComponent;

    constructor(private titleService: GfTitleService, private modalService: NgbModal) {}

    ngOnInit() {
        this.titleService.setTitle(this.project.name, 'Admin', 'Webhook Subscriptions');
    }

    private openModal(subscriptionId: number) {
        const ref = this.modalService.open(EventSubscriptionModalComponent, { size: 'lg' });
        ref.componentInstance.subscriptionId = subscriptionId;
        ref.componentInstance.projectId = this.project?.id ?? null;
        ref.result.then(() => {
            if (this.subscriptionList) { this.subscriptionList.load(); }
        }, () => {});
    }

    onEdit(id: number) { this.openModal(id); }
    onCreate() { this.openModal(0); }
}
